import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Button } from "@mui/material";
import moment from "moment";
import RejectReasonModal from "../../Modals/rejectReason";
import { useLazyGetBannerDetailQuery } from "../../services/banner";
import { useLazyGetBookingDetailQuery } from "../../services/booking";
import { showError } from "../../constants/toasts";
import { BookingDetail } from "../../types/General";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BookingDetails = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
 

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const { id } = useParams();

  const [bookingDetails] = useLazyGetBookingDetailQuery();
  const [bookingData, setBookingData] = useState<BookingDetail | null>(null);
  const [loading, setLoading] = useState(false);

   const getDataByIdList = async () => {
      try {
        setLoading(true);
        if (!id) return;
        const response = await bookingDetails({ id }).unwrap();
        if (response.statusCode === 200) setBookingData(response.data);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);
        showError(error?.message || error?.data?.message);
      }
    };

    useEffect(()=>{
      if(id){
        getDataByIdList()
      }
    },[])

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>Bookings Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-booking-requests")}>
              Manage Bookings
            </span>{" "}
            - Bookings Detail
          </p>
        </div>
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                {/* <Tab label="Offers History" {...a11yProps(1)} /> */}
              </Tabs>
            </Box>
          </div>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Venue/Storage Details</h2>
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>Type</h6>
                <p>{bookingData?.type || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Booking Status</h6>
                <p>{bookingData?.bookingStatus || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Start Time</h6>
                <p>
                  {bookingData?.startTime
                    ? moment(bookingData.startTime).format("DD MMM YYYY, hh:mm A")
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>End Time</h6>
                <p>
                  {bookingData?.endTime
                    ? moment(bookingData.endTime).format("DD MMM YYYY, hh:mm A")
                    : "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>User Name</h6>
                <p>
                  {bookingData?.user?.name ||
                    [bookingData?.user?.firstName, bookingData?.user?.middleName, bookingData?.user?.lastName]
                      .filter(Boolean)
                      .join(" ") || "-"}
                </p>
              </div>
              <div className="w_33">
                <h6>User Email</h6>
                <p>{bookingData?.user?.email || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Name</h6>
                <p>{bookingData?.venueStorage?.name || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Category</h6>
                <p>{bookingData?.categoryDetail?.name || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Address</h6>
                <p>{bookingData?.venueStorage?.address || "-"}</p>
              </div>
              <div className="w_100">
                <h6>Description</h6>
                <p>{bookingData?.venueStorage?.description || "-"}</p>
              </div>
              <div className="w_33">
                <h6>Per Hour</h6>
                <p>{bookingData?.venueStorage?.setPricing?.perHour ?? "-"}</p>
              </div>
              <div className="w_33">
                <h6>Per Day</h6>
                <p>{bookingData?.venueStorage?.setPricing?.perDay ?? "-"}</p>
              </div>
              <div className="w_33">
                <h6>Per Person</h6>
                <p>{bookingData?.venueStorage?.setPricing?.perPerson ?? "-"}</p>
              </div>
            </div>
          </div>

          <div className="cards view_page">
            <div className="section_title">
              <h2>Images</h2>
            </div>
            <div className="gap_p">
              {(bookingData?.venueStorage?.images || []).map((img, idx) => (
                <div className="w_33" key={idx}>
                  <figure className="passport_img">
                    <img src={img} alt={`venue-${idx}`} />
                  </figure>
                </div>
              ))}
              {!bookingData?.venueStorage?.images?.length && (
                <div className="w_100">
                  <p>-</p>
                </div>
              )}
            </div>
          </div>
        </CustomTabPanel>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onSubmit={() => {}}
      />
    </>
  );
};

export default BookingDetails;
